// src/components/AppointmentConstants.js
//
// Randevu durum sözlüğü ve şema üreticisi — TEK KAYNAK.
// Takvim, Randevu Listesi, Randevu Detay ve randevu modalları buradan okur;
// durum dizileri artık hiçbir ekranda elle tekrarlanmaz.
//
// Canlı veri notu (Faz 1 teşhisi, Detailing 216): 22 randevunun 7'sinde 'durum'
// alanı hiç yok — durum-in filtresi bu kayıtları takvimden tamamen gizliyordu.
// Legacy harita ('Iptal', 'Geldi' vb.) ihtiyaten korunur; normalizeRandevuDurum
// tüm yazımları kanonik dört değere indirir.

import { Timestamp } from 'firebase/firestore';

export const RANDEVU_DURUMLARI = ['Bekleniyor', 'Onaylandı', 'Tamamlandı', 'İptal'];

export const VARSAYILAN_RANDEVU_DURUMU = 'Bekleniyor';

export const LEGACY_DURUM_HARITASI = {
    'Iptal': 'İptal',
    'iptal': 'İptal',
    'IPTAL': 'İptal',
    'Geldi': 'Tamamlandı',
    'Gelmedi': 'Tamamlandı',
    'Tamamlandi': 'Tamamlandı',
    'Onaylandi': 'Onaylandı',
    'Onayladi': 'Onaylandı'
};

export const normalizeRandevuDurum = (durum) => {
    if (!durum || typeof durum !== 'string') return VARSAYILAN_RANDEVU_DURUMU;
    const temiz = durum.trim();
    if (RANDEVU_DURUMLARI.includes(temiz)) return temiz;
    return LEGACY_DURUM_HARITASI[temiz] || VARSAYILAN_RANDEVU_DURUMU;
};

export const isIptalRandevu = (durum) => normalizeRandevuDurum(durum) === 'İptal';

export const getRandevuDurumColor = (durum) => {
    const colors = {
        'Bekleniyor': 'info',
        'Onaylandı': 'success',
        'Tamamlandı': 'primary',
        'İptal': 'error'
    };
    return colors[normalizeRandevuDurum(durum)] || 'default';
};

export const randevuEtkinlikTurleri = [
    'Görüşme',
    'Müşteri Araç Teslim Alma',
    'Müşteri Araç Kontrol',
    'Müşteri Araç Teslimi'
];

export const randevuHizmetTurleri = [
    'Paketler', 'Cam Filmi', 'PPF Kaplama', 'Seramik Kaplama',
    'Detay Temizlik', 'Yıkama', 'Göçük Düzeltme', 'Diğer'
];

const toDate = (value) => {
    if (!value) return null;
    try {
        const d = value.toDate ? value.toDate() : new Date(value);
        return isNaN(d.getTime()) ? null : d;
    } catch {
        return null;
    }
};

// Okuma tarafı geriye dönük uyum: yeni kayıtlar 'start' yazar,
// v1 kayıtlarının bir kısmı yalnızca 'randevuTarihi' taşıyor.
export const getRandevuStart = (app) => toDate(app?.start) || toDate(app?.randevuTarihi);

export const getRandevuEnd = (app) => toDate(app?.end);

const toTimestamp = (value) => {
    if (value instanceof Timestamp) return value;
    const d = toDate(value);
    return d ? Timestamp.fromDate(d) : null;
};

// Randevu şeması tek üreticiden çıkar. 'customerId' bilerek koşullu:
// canlıda 31 randevu boş string customerId taşıyor (RandevuOlusturModal'ın
// `musteriId || ''` yazımından) ve bu boş değer müşteri linklerini de
// eşitlik sorgularını da bozuyor. Müşteri bağlı değilse alan HİÇ yazılmaz.
export const buildAppointmentData = ({
    customerName,
    customerPhone,
    customerId,
    serviceType,
    eventType,
    notes,
    start,
    end,
    durum,
    ...extra
} = {}) => {
    const startTs = toTimestamp(start);
    const endTs = toTimestamp(end);
    if (!startTs || !endTs) {
        throw new Error('Randevu başlangıç ve bitiş zamanı zorunludur.');
    }

    const data = {
        customerName: customerName || '',
        customerPhone: customerPhone || '',
        serviceType: serviceType || '',
        eventType: eventType || 'Görüşme',
        notes: notes || '',
        start: startTs,
        end: endTs,
        durum: normalizeRandevuDurum(durum),
        ...extra
    };

    if (customerId) data.customerId = customerId;
    return data;
};
